import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Modal } from "@mui/material";
import axios from "axios";
import { useTranslation } from "react-i18next";

import classes from "./ExtraCurricular.module.css";

const ExtraCurricular = ({ extraCurricular, index }) => {
  const { t } = useTranslation();
  const [selectedEvent, setSelectedEvent] = useState("");
  const [openModal, setOpenModal] = useState();
  const [nameMessage, setNameMessage] = useState("");
  const [phoneNumberMessage, setPhoneNumberMessage] = useState("");

  const token = "6376242475:AAGK4MekEeokENyrBzO69QceX0Wjf3C0AGQ";

  const onClickOpenModal = (evenName) => {
    setSelectedEvent(evenName);
    setOpenModal(true);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const chatId = 795052103;

      const url = `https://api.telegram.org/bot${token}/sendMessage`;

      const response = await axios.post(url, {
        chat_id: chatId,
        text: `
        ${nameMessage} ${selectedEvent} tadbiriga qoshilmoqchi, telefon raqam: ${phoneNumberMessage}`,
      });

      setNameMessage("");
      setPhoneNumberMessage("");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={classes["box"]}>
      <h3 className={classes["title"]}>{extraCurricular.title}</h3>

      <p className={classes["text"]}>{extraCurricular.description}</p>
      <br />
      <div className={classes["flex"]}>
        <Icon className={classes["icon"]} icon="ic:outline-date-range" />
        <p className={classes["text"]}>Sana: {extraCurricular.date}</p>
      </div>
      <div className={classes["flex"]}>
        <Icon className={classes["icon"]} icon="pajamas:requirements" />
        <p className={classes["text"]}>
          Talablar: {extraCurricular.requirements}
        </p>
      </div>
      <button
        onClick={() => onClickOpenModal(extraCurricular.title)}
        className={classes["btn"]}
      >
        Qoshilish+
      </button>
      <div className={classes["number"]}>0{index + 1}</div>
      <Modal
        style={{ width: "100%" }}
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <div className={classes["modal"]}>
          <form onSubmit={handleSubmit}>
            <div className={classes["input-wrapper"]}>
              <p className={classes["input-title"]}>
                Siz yozilmoqchi bolgan tadbir:
                <span>{selectedEvent}</span>
              </p>
              <input
                placeholder="Abdullokh"
                className={classes["input"]}
                type="text"
                value={nameMessage}
                onChange={(e) => setNameMessage(e.target.value)}
                required
              />
              <input
                placeholder="+998988880448"
                className={classes["input"]}
                type="number"
                value={phoneNumberMessage}
                onChange={(e) => setPhoneNumberMessage(e.target.value)}
                required
              />
              <button type="submit" className={classes["send-button"]}>
                {t("Jonatish")}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default ExtraCurricular;
